module.exports = __webpack_public_path__ + "static/media/mouseHint.9f6aaebe.svg";